export const getTailwindClass = (tagName: string): string => {
  const baseStyle = 'mb-[20px]';
  switch (tagName) {
    case 'p':
      return `${baseStyle} text-h5Regular text-neutral-900`;
    case 'h3':
      return `${baseStyle} text-h3Regular text-neutral-900`;
    case 'figure':
      return `${baseStyle} flex overflow-auto`;
    case 'ul':
      return `${baseStyle} text-h5Regular text-neutral-900`;
    case 'hr':
      return `${baseStyle} py-[20px]`;
    default:
      return '';
  }
};
